import {
  Document,
  PDFViewer,
  Page as PDFPage,
  StyleSheet,
  Text as PDFText,
  View as PDFView,
  Font,
  Image as PDFImage
} from '@react-pdf/renderer';
import { calculateAge } from '../../../../../utils/common';

Font.register({
  family: 'Roboto',
  fonts: [{ src: '/Roboto-Bold.ttf', fontWeight: 'medium' }]
});

const fullScreenStyles = {
  container: {
    position: 'fixed',
    top: 0,
    left: 0,
    width: '100vw',
    height: '100vh',
    zIndex: 1000,
    backgroundColor: 'white'
  }
};

const styles = StyleSheet.create({
  page: {
    justifyContent: 'flex-start',
    alignItems: 'center'
  },
  text: {
    fontSize: 10
  },
  textUnderlined: {
    fontSize: 10,
    textDecoration: 'underline',
    textDecorationColor: 'black',
    textDecorationThickness: 1.5,
    width: '120%'
  },
  heading: {
    fontSize: 14,
    fontWeight: 'bold',
    textAlign: 'center'
  },
  contentContainer: {
    display: 'flex',
    flexDirection: 'row',
    width: '100%',
    gap: 5,
    paddingBottom: '3px',
    borderBottom: '1px solid black',
    paddingTop: '125px',
    paddingRight: '30px',
    paddingLeft: '30px'

  },
  column: {
    width: '33%',
    display: 'flex',
    flexDirection: 'column',
    gap: 1
  },
  row: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    marginBottom: 5
  },
  label: {
    fontWeight: 'bold',
    fontSize: 10
  },
  value: {
    fontSize: 10,
    fontWeight: 'normal',
    width: '65%'
  }
});

const Page = ({ style, children, ...props }) => (
  <PDFPage style={{ ...styles.page, ...style }} {...props}>
    {children}
  </PDFPage>
);

const View = ({ style, children, ...props }) => (
  <PDFView style={{ ...style }} {...props}>
    {children}
  </PDFView>
);

const Text = ({ style, content, ...props }) => (
  <PDFText style={{ ...styles.text, ...style }} {...props}>
    {content}
  </PDFText>
);

export const PatientRegistrationPdf17 = ({ data }) => {
  function formatDate(dateString) {
    const date = new Date(dateString);
    const istParts = new Intl.DateTimeFormat('en-GB', {
      timeZone: 'Asia/Kolkata',
      day: '2-digit',
      month: '2-digit',
      year: 'numeric'
    }).formatToParts(date);
    const day = istParts.find((p) => p.type === 'day').value;
    const month = istParts.find((p) => p.type === 'month').value;
    const year = istParts.find((p) => p.type === 'year').value;
    return `${day}/${month}/${year}`;
  }
  const ageString = data.age;
  const years = ageString.match(/\d+Y/);
  return (
    <div style={fullScreenStyles.container}>
      <PDFViewer width="100%" height="100%" showToolbar>
        <Document title={`${data.name} Registration`}>
          <Page size="A4" style={styles.page}>
            <PDFImage src="/Godavariprint.png" style={{ width: '100%', height: '100%' }} />
          </Page>

          <View style={{ ...styles.row }}>
            <Text
              content={`${data.op_no}`}
              style={{
                ...styles.value,
                textAlign: 'start',
                marginLeft: '43%',
                marginTop: '21.5%',
                fontSize: '12px'
              }}
            />
          </View>

          <View style={{ ...styles.row }}>
            <Text
              content={`${formatDate(data.reg_date)}`}
              style={{
                ...styles.value,
                textAlign: 'start',
                marginLeft: '83%',
                marginTop: '21.5%',
                fontSize: '12px'
              }}
            />
          </View>

          <View style={{ ...styles.row }}>
            <Text
              content={`${data.name}`}
              style={{
                ...styles.value,
                textAlign: 'start',
                marginLeft: '39%',
                marginTop: '25.2%',
                fontSize: '12px'
              }}
            />
          </View>

          <View style={{ ...styles.row }}>
            <Text
              content={`${calculateAge(data.dob)}Y`}
              style={{
                ...styles.value,
                textAlign: 'start',
                marginLeft: '75%',
                marginTop: '25.2%',
                fontSize: '12px'
              }}
            />
          </View>

          <View style={{ ...styles.row }}>
            <Text
              content={`${data.gender}`}
              style={{
                ...styles.value,
                textAlign: 'start',
                marginLeft: '88%',
                marginTop: '25.2%',
                fontSize: '12px'
              }}
            />
          </View>

          <View style={{ ...styles.row }}>
            <Text
              content={`${data.total}`}
              style={{
                ...styles.value,
                textAlign: 'start',
                marginLeft: '72%',
                marginTop: '29.2%',
                fontSize: '12px'
              }}
            />
          </View>
        </Document>
      </PDFViewer>
    </div>
  );
};
